import { createRoot } from "react-dom/client";
import App from "./App.tsx";
import "./index.css";
import { installErrorMonitor, isSentryActive } from "./lib/errorMonitor";
import { trackEvent } from "./lib/analytics";
import { installPushSwListener } from "./lib/pushSubscription";
import { installSwUpdatePrompt } from "./lib/swUpdate";

installErrorMonitor();
console.info('[Sentry] active:', isSentryActive());

// SW failure visibility + push message forwarding + config injection
if ('serviceWorker' in navigator) {
  const injectConfig = (target: ServiceWorker | null) => {
    if (!target) return false;
    target.postMessage({
      type: 'SUPABASE_CONFIG',
      supabaseUrl: import.meta.env.VITE_SUPABASE_URL,
      anonKey: import.meta.env.VITE_SUPABASE_PUBLISHABLE_KEY,
    });
    return true;
  };

  navigator.serviceWorker.ready.then((reg) => {
    // Prefer controller (active page), fallback to reg.active
    const sent = injectConfig(navigator.serviceWorker.controller) || injectConfig(reg.active);
    // Retry after 500ms if controller wasn't ready (cold install)
    if (!sent) {
      setTimeout(() => {
        if (!injectConfig(navigator.serviceWorker.controller)) {
          injectConfig(reg.active);
        }
      }, 500);
    }
  }).catch((err) => {
    trackEvent('push_sw_error', { message: String(err?.message || err) });
  });
  installPushSwListener();
  // Prompt-on-update registration (replaces bare register('/sw.js'))
  installSwUpdatePrompt();
}

createRoot(document.getElementById("root")!).render(<App />);

